import React, { FC } from 'react'
import styles from 'styles/components/footer.module.scss'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

type Props = {
  label: string
  target: '_self' | '_blank'
  url: string
}

const FooterSitemapItem: FC<Props> = (props) => {
  const { label, target, url } = props
  const dispatch = useDispatch()

  return (
    <li className={styles.footer__sitemap__item}>
      <a
        role={'button'}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : ''}
        onClick={() => (target === '_blank' ? window.open(url) : dispatch(push(url)))}
      >
        {label}
      </a>
    </li>
  )
}

export default FooterSitemapItem
